import { tokenHelper } from ".";
import { EmployeeToken, ExpiringTokenPayload, RefreshToken, TokenReadResult, UserToken } from "../..";

export const tokenReader = {
    tryReadUserToken,
    tryReadRefreshToken,
    tryReadEmployeeToken
}

function tryReadUserToken(token:string | null | undefined, decoder:(token:string)=>ExpiringTokenPayload, expiryInSeconds?:number)
    :TokenReadResult<UserToken>
{
    if(!token)
        return { status: 'no-token' };

    try {
        const payload = decoder(token);

        const verificationResult = tokenHelper.verifyTokenPayload(payload, expiryInSeconds);

        if(verificationResult.status === 'no-token' || verificationResult.status === 'invalid')
            return verificationResult;

        const userTokenResult = tokenHelper.parseUserToken(verificationResult.token);
        if(userTokenResult.status === 'success'){
            return {
                status: verificationResult.status,
                token: userTokenResult.token
            };
        }
        else {
            return {
                status: 'invalid',
                errorMessage: userTokenResult.errorMessage
            };
        }
    }
    catch(e:any){
        return { status: 'invalid', errorMessage: e?.message || 'no message defined' };
    }
}

function tryReadRefreshToken(token:string | null | undefined, decoder:(token:string)=>ExpiringTokenPayload, expiryInSeconds?:number)
    :TokenReadResult<RefreshToken>
{
    if(!token)
        return { status: 'no-token' };

    try{
        const payload = decoder(token);
        const verificationResult = tokenHelper.verifyTokenPayload(payload, expiryInSeconds);

        if(verificationResult.status === 'no-token' || verificationResult.status === 'invalid')
            return verificationResult;

        const refreshTokenResult = tokenHelper.parseRefreshToken(verificationResult.token);
        if(refreshTokenResult.status === 'success'){
            return {
                status: verificationResult.status,
                token: refreshTokenResult.token
            };
        }
        else {
            return {
                status: 'invalid',
                errorMessage: refreshTokenResult.errorMessage
            };
        }
    }
    catch(e:any){
        return { status: 'invalid', errorMessage: e?.message || 'no message defined' };
    }
}


function tryReadEmployeeToken(token:string | null | undefined, decoder:(token:string)=>ExpiringTokenPayload, expiryInSeconds?:number)
    :TokenReadResult<EmployeeToken>
{
    if(!token)
        return { status: 'no-token' };

    try {
        const payload = decoder(token);
        const verificationResult = tokenHelper.verifyTokenPayload(payload, expiryInSeconds);

        if(verificationResult.status === 'no-token' || verificationResult.status === 'invalid')
            return verificationResult;

        const employeeTokenResult = tokenHelper.parseEmployeeToken(verificationResult.token);
        if(employeeTokenResult.status === 'success'){
            return {
                status: verificationResult.status,
                token: employeeTokenResult.token
            };
        }
        else {
            return {
                status: 'invalid',
                errorMessage: employeeTokenResult.errorMessage
            };
        }
    }
    catch(e:any){
        return { status: 'invalid', errorMessage: e?.message || 'no message defined' };
    }
}